module.exports = __webpack_public_path__ + "static/media/cv-library-free-no-bg.d7ae3825.svg";